import { PermissionCode, ResourceCode } from '@/const/code'

export default [
  {
    path: '/cache',
    name: 'cache',
    component: () => import('@/views/cache/index.vue'),
    meta: {
      pageTitle: 'Quản lý cache',
      breadcrumb: [
        {
          text: 'Hệ thống',
          active: false,
        },
        {
          text: 'Quản lý cache',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CACHE,
    },
  },
]
